import { render, staticRenderFns } from "./LanguagesView.vue?vue&type=template&id=40e1300a&scoped=true"
import script from "./LanguagesView.vue?vue&type=script&lang=js"
export * from "./LanguagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1300a",
  null
  
)

export default component.exports